jQuery(document).ready(function ($) {
    // TODO: Do not ddd block/template specific JS here, instead create a new directory/file for each block/template.
});
